export const clearedFilters = {
    customerType: -1,
    orderType: -1,
};
